import React from 'react'
import {withRouter, Switch, Route} from 'react-router-dom'

import Loader from 'components/Loader'
import UserContext from 'components/User/UserContext'
import MainLayout from 'modules'
import MainLayoutPublic from 'modulesPublic'
import 'styles/App.less'
import handleRefreshToken from 'utils/handleRefreshToken'

const App = ({history}) => {
  const [user, setUser] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => handleRefreshToken(history, setUser, setLoading), [history])

  return (
    <UserContext.Provider value={{user, setUser}}>
      {loading ? (
        <Loader/>
      ) : (
        <Switch>
          <Route exact path={['/', '/register/:token?']} component={MainLayoutPublic}/>
          {user && <Route path='/home' component={MainLayout}/>}
        </Switch>
      )}
    </UserContext.Provider>
  )
}

export default withRouter(App)
